export const feedbackResponse = {
  type: "object",
  properties: {
    result: { type: "string" },
  },
  required: ["result"],
  additionalProperties: true,
};
